<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{ "IO.HEADER" | translate }}</mat-card-title>
        
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <mat-accordion>
                <mat-expansion-panel [(ngModel)]="ecu.expanded" [(expanded)]="ecu.expanded" *ngFor="let ecu of ecus" ngDefaultControl>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ecu.name}}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-in-out
                        [ecuId]="ecu.id"
                        [expanded]="ecu.expanded"
                    ></app-in-out>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </mat-card-content>
    </div>
</mat-card>